// A room-type listing checks pooled availability across its member units;
// booking submit then assigns a free unit (room_type_booking).
const isRoomTypeCheckout = (listing, unit) =>
  Boolean(listing && listing.is_room_type && unit && unit.room_type_id);

const checkoutAvailabilityRequest = ({
  listing,
  unit,
  bookingRange,
  guests,
  quoteId
}) => {
  const roomType = isRoomTypeCheckout(listing, unit);
  const params = {
    unit_id: unit.id,
    booking_range: JSON.stringify(bookingRange),
    guests
  };
  if (quoteId && !roomType) params.quote_id = quoteId;
  return { roomType, params };
};

module.exports = { isRoomTypeCheckout, checkoutAvailabilityRequest };
